(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.DataManagementService = (function(superClass) {
    extend(DataManagementService, superClass);

    function DataManagementService(http, rootScope) {
      this.http = http;
      this.rootScope = rootScope;
      this.getConfirmedSettings = bind(this.getConfirmedSettings, this);
      this.getProducts = bind(this.getProducts, this);
      this.getSeedCompanies = bind(this.getSeedCompanies, this);
      this.loadScopeData = bind(this.loadScopeData, this);
      this.persistSelections = bind(this.persistSelections, this);
      this.saveSelections = bind(this.saveSelections, this);
      this.getGroupByValues = bind(this.getGroupByValues, this);
      this.getManagementZoneRows = bind(this.getManagementZoneRows, this);
      this.setRows = bind(this.setRows, this);
      this.getRows = bind(this.getRows, this);
      this.rows = null;
    }

    DataManagementService.prototype.getRows = function(type) {
      return this.http.post('backend/grower/maps-conversion/get-rows', {
        type: type
      });
    };

    DataManagementService.prototype.setRows = function(rows) {
      return this.rows = rows;
    };

    DataManagementService.prototype.getManagementZoneRows = function(skip, take) {
      return this.http.post('backend/grower/maps-conversion/get-management-zone-rows', {
        skip: skip,
        take: take
      });
    };

    DataManagementService.prototype.getGroupByValues = function(row) {
      return this.http.post('backend/grower/maps-conversion/get-group-by-values', {
        row: row
      });
    };

    DataManagementService.prototype.saveSelections = function(altered_row, tab) {
      var child, childSelections, i, ref, ref1, row, savedSelections, selections;
      savedSelections = [];
      ref = this.rows;
      for (i in ref) {
        row = ref[i];
        selections = {
          field_id: row.reference.field_id,
          year: row.reference.year,
          selected: row.selected,
          children: []
        };
        ref1 = row.children;
        for (i in ref1) {
          child = ref1[i];
          childSelections = {
            id: child.end.id,
            selected: child.selected
          };
          selections.children.push(childSelections);
        }
        savedSelections.push(selections);
      }
      return this.persistSelections(tab, savedSelections, altered_row);
    };

    DataManagementService.prototype.persistSelections = function(tab, selections, row) {
      return this.http.post('backend/grower/maps-conversion/save-user-selections', {
        tab: tab,
        user_selections: selections
      }).then((function(_this) {
        return function(response) {
          return _this.rootScope.$broadcast('row:updated', {
            row: row
          });
        };
      })(this));
    };

    DataManagementService.prototype.loadScopeData = function(promise, key) {
      promise.then((function(_this) {
        return function(response) {
          var ref, ref1;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            return _this.scope[key] = response.data.data;
          }
        };
      })(this));
      return promise;
    };

    DataManagementService.prototype.getSeedCompanies = function(row) {
      return this.http.post('backend/grower/maps-conversion/get-seed-companies', {
        crops_id: row.selected.crop.id
      }).then((function(_this) {
        return function(response) {
          var child, i, ref;
          if (response.data.status.type === 'success') {
            row.selected.seed_company = null;
            row.selected.product = null;
            row.required.seed_companies = response.data.data;
            if (row.children != null) {
              ref = row.children;
              for (i in ref) {
                child = ref[i];
                child.selected.seed_company = null;
                child.selected.product = null;
                child.required.seed_companies = response.data.data;
              }
            }
          }
          return _this.saveSelections(row, _this.tab);
        };
      })(this));
    };

    DataManagementService.prototype.getProducts = function(row, rows) {
      var crops_id, sc_id;
      crops_id = row.selected.crop.id;
      sc_id = row.selected.seed_company.id;
      return this.http.post('backend/grower/maps-conversion/get-products', {
        crops_id: crops_id,
        seed_companies_id: sc_id
      }).then((function(_this) {
        return function(response) {
          var child, i, ref;
          if (response.data.status.type === 'success') {
            row.selected.product = null;
            row.required.products = response.data.data;
            if (row.children != null) {
              ref = row.children;
              for (i in ref) {
                child = ref[i];
                child.selected.product = null;
                child.required.products = response.data.data;
              }
            }
          }
          return _this.saveSelections(row, _this.tab);
        };
      })(this));
    };

    DataManagementService.prototype.getConfirmedSettings = function(vps) {
      return this.http.post('backend/grower/maps-conversion/get-confirmed-settings', {
        vps: vps
      });
    };

    return DataManagementService;

  })(Service);

}).call(this);
